
import React from 'react'
import Layout from '../../components/layout'

import CustomerLogos from '../../components/customerlogos'

import QouteCard from '../../components/qoutecard'

import avatar_jl from '../../assets/employees/johan-profil.jpg'
import avatar_gl from '../../assets/employees/gustav-profil.jpg'
import avatar_rn from '../../assets/employees/robert-profil.jpg'

const qoutes = [
  { name: "Johan Lahti", avatar: avatar_jl, title: "Sr. Consultant & CEO", qoute: "I en modern arkitektur är nätverket designat för att automatiseras och automationslösningen är skräddarsydd för nätverket. " },
  { name: "Gustav Larsson", avatar: avatar_gl, title: "Sr. Consultant", qoute: "Våra välutvecklade processer gör det möjligt för oss att skapa skräddarsydda team som levererar verkligt värde. Genom noggranna reviewprocesser och samarbete ser vi till att varje leverans håller högsta kvalitet!" },
  { name: "Robert Nilsson", avatar: avatar_rn, title: "Sr. Consultant & Manager", qoute: "En stark kultur bygger på ödmjukhet, tillit och yrkesstolthet. Genom att kombinera professionalism, trygghet och ständig utveckling skapar vi en miljö där teamet växer tillsammans – både tekniskt och som individer." }
]


export default function AboutPage() {
  return (
    <Layout>
      <div id="about" className="section">
        <div>
          <div className="flex flex-col gap-4 text-xl">
            <p className="text-3xl">
              2020 grundades <span className="text-sky-500">AceBit</span> med en vision om att ett modernt, automatiserat nätverk kräver kunskap inom både nätverks- och systemutveckling.
            </p>
            <p>
              Vår syn på nätverksdesign utgår från att dessa områden måste harmoniseras för att skapa riktigt bra lösningar som skalar och bringar verklig nytta till verksamheten!
            </p>
            <p>
              Idag har vi byggt ett erfaret team på vår <span className="text-sky-500">vision</span> - som kombinerar expertis inom design, implementation
              och drift av det vi kallar moderna nätverk. Målet är inte bara följa de senaste trenderna, utan även att våga utforska och utveckla framtidens nätverkslösningar – the <span className="text-sky-500">AceBit</span> way.
            </p>
          </div>
          <div className="flex py-8 flex-wrap gap-8 justify-center">

            {qoutes.map((item) => (
              <div key={item.name}>
                <QouteCard
                  name={item.name}
                  title={item.title}
                  qoute={item.qoute}
                  avatar={item.avatar}
                />
              </div>

            ))}

          </div>

          {/* Tar bort kundlogos tills vi hunnit kolla att vi får ha dom */}

          {/* <div>
            <hr className="my-12 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10" />
            <p className="text-lg text-gray-700">Några av våra kunder:</p>
            <CustomerLogos />
          </div> */}
        </div>
      </div>
    </Layout>
  )
}
